import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from 'hooks/shared/error';
import { layerNodesKeys } from './queryKeys';
import type { CreateLayerFolderNodeBody, LayerNodeDto } from './types';

export function useCreateLayerFolderNodeMutation() {
  const queryClient = useQueryClient();

  return useMutation<LayerNodeDto, unknown, CreateLayerFolderNodeBody>({
    mutationFn: async (input: CreateLayerFolderNodeBody) => {
      const resp = await axios.post<LayerNodeDto>(
        `${config.apiGateway.layer_nodes}/folder`,
        input
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('Category created');
      queryClient.invalidateQueries({
        queryKey: layerNodesKeys.all(),
      });
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
